import { useMutation } from '@gogame/query';
import { useScreenModalV2 } from '@gogame/screens';

import ConfirmDialog from 'scenes/IO/components/ConfirmDialog';
import { GetIOEntityName } from 'scenes/IO/helpers';
import { undoIo } from 'scenes/IO/sources/io';

import { undo } from '../queryKeyFactory';

export const useUndoIo = (io) => {
  const entityName = GetIOEntityName(io);
  const showModal = useScreenModalV2(ConfirmDialog);
  const undoMutation = useMutation(undo(), undoIo, {
    successMessage: () => `${entityName} undone`,
  });
  const handleUndo = async () => {
    const { id } = io;
    await showModal({
      title: `Undo ${entityName}?`,
      io: io,
      confirmActionLabel: 'Undo',
    });

    await undoMutation.mutateAsync({ id });
  };

  return [handleUndo, undoMutation];
};
